export const RESET_PASSWORD_GENERATE_REQUEST = 'RESET_PASSWORD_GENERATE_REQUEST'
export const RESET_PASSWORD_GENERATE_SUCCESS = 'RESET_PASSWORD_GENERATE_SUCCESS'
export const RESET_PASSWORD_GENERATE_FAILURE = 'RESET_PASSWORD_GENERATE_FAILURE'

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'
